export default "__VITE_ASSET__BXZnhCfv__"